import {
  getVisaDocumentKey,
  getVisaDocumentsKey,
  useGetVisaDocument,
  useGetVisaDocuments,
  VisaDocumentLiteModel,
  VisaDocumentModel,
} from 'api-hooks/visa-document';
import { Option } from 'baseui/select';
import { NavigationRoutes } from 'common/constants';
import { ModelTransformer } from 'common/helpers/common';
import { ColumnDataType } from 'components/elements/table/type';
import React from 'react';

import useGetCrudPermission from './use-get-crud-permission';
import useNavigation from './use-navigation';

export function visaOptionsTransformer(item: VisaDocumentLiteModel): Option {
  return {
    id: item.id,
    label: item.name,
    visaDocumentId: item.id,
    price: item.price || 0,
  };
}

export default function useGetVisaColumn() {
  const permission = useGetCrudPermission('visa-documents');
  const { navigate } = useNavigation();

  return React.useMemo(() => {
    return {
      dataType: ColumnDataType.select,
      useListQueryHook: useGetVisaDocuments,
      useDetailLazyQueryHook: useGetVisaDocument,
      listKeyFunction: getVisaDocumentsKey,
      detailKeyFunction: getVisaDocumentKey,
      getMemoizedListVariables: (page, q) => ({
        params: {
          q,
          page,
        },
      }),
      getMemoizedDetailVariables: (value: string) => ({
        id: value,
      }),
      listTransformer: (result) => {
        return result.data.map((v) => {
          const data = ModelTransformer(v, VisaDocumentLiteModel);
          return visaOptionsTransformer(data);
        });
      },
      detailTransformer: (result) => {
        const data = ModelTransformer(result.data, VisaDocumentModel);
        return visaOptionsTransformer(data);
      },
      paginationTransformer: (result) => {
        return result.meta;
      },
      filterOptions: null,

      renderCreate: permission.create,
      onClickCreate: () => {
        navigate(NavigationRoutes.VisaDocumentCreate);
      },
    };
  }, [navigate, permission.create]);
}
